import { useQuery } from "@apollo/client";

import { GET_RECOMMENDATIONS_QUERY } from "./documents";
import { TGetRecommendationsData } from "./types";

export function useGetRecommendationsQuery() {
  const query = useQuery<TGetRecommendationsData>(GET_RECOMMENDATIONS_QUERY);

  return query;
}
